<template>
  <div class="reward-config">
    <el-card>
      <el-tabs type="border-card" v-model="activeName">
        <el-tab-pane label="签到奖励" name="1">
          <sign-in-reward v-if="activeName === '1'"></sign-in-reward>
        </el-tab-pane>

        <el-tab-pane label="直播在线宝箱奖励" name="2">
          <time-box-reward v-if="activeName === '2'"></time-box-reward>
        </el-tab-pane>
        <el-tab-pane label="通用奖品信息配置" name="3">
          <app-config-reward v-if="activeName === '3'"></app-config-reward>
        </el-tab-pane>
        <el-tab-pane label="奖励key配置" name="4">
          <rewardKeyConfig v-if="activeName === '4'"></rewardKeyConfig>
        </el-tab-pane>
        <el-tab-pane label="奖励id参考表" name="5">
          <config-table v-if="activeName === '5'"></config-table>
        </el-tab-pane>
        <el-tab-pane label="跳转配置" name="6">
          <jump-config v-if="activeName === '6'"></jump-config>
        </el-tab-pane>
        <el-tab-pane label="用户任务奖励配置" name="7">
          <user-task-score-config v-if="activeName === '7'"></user-task-score-config>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>
<script>
import signInReward from '../../components/rewardConfig/sign-in-reward.vue'
import timeBoxReward from '../../components/rewardConfig/time-box-reward.vue'
import configTable from '../../components/rewardConfig/config-table.vue'
import appConfigReward from '../../components/rewardConfig/app-config-reward.vue'
import rewardKeyConfig from '../../components/rewardConfig/reward-key-config.vue'
import jumpConfig from '../../components/rewardConfig/jump-config.vue'
import userTaskScoreConfig from '../../components/rewardConfig/user-task-score-config.vue'
export default {
  components: {
    signInReward,
    configTable,
    timeBoxReward,
    appConfigReward,
    rewardKeyConfig,
    jumpConfig,
    userTaskScoreConfig,
  },
  data() {
    return {
      activeName: '1',
    }
  },
  mounted() {
    // this.activeName = this.$route.query.active?.toString() || 1
  },
  methods: {},
}
</script>
<style scoped lang="scss"></style>
